import type { PartnerFormData } from '@/types'

export const EMPTY_PARTNER_FORM: PartnerFormData = {
  nome: '', empresa: '', email: '', telefone: '',
  comissao: '', cnpj: '', responsavel: '',
  telefoneContato: '', chavePix: '', indicadoPorId: '',
  modoComissao: 'RECORRENTE',
}

export const buildTrendData = (total: number, points = 12) => {
  const base = Math.max(1, total)
  return Array.from({ length: points }, (_, i) => {
    const progress = points === 1 ? 1 : i / (points - 1)
    const wave = Math.sin(progress * Math.PI) * 0.18
    return Math.max(0, Math.round(base * (0.65 + progress * 0.35 + wave)))
  })
}
